import * as React from 'react';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import Link from '@src/components/link';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import styles from './index.less';
import Store from './store';

const lang = getLanguageByPath();

const PhotoDetailModal = ({ store, onClose }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }

  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={styles.ImageDetailModalRoot}>
        <div className={styles.imagePanel}>
          <Link
            className={styles.btnClose}
            onClick={() => {
              store.onClickClose();
              onClose();
            }}
          />
          <div onClick={store.downloadCrossOriginImage} className={styles.btnDownload}>
            <div className={styles.btnDownloadNormal} style={{ backgroundImage: `url(${require('./images/' + lang + '/btn-download.png')})` }} />
            <div className={styles.btnDownloadHover} style={{ backgroundImage: `url(${require('./images/' + lang + '/btn-download-hover.png')})` }} />
          </div>
          <img id={'expand-img'} src={store.src} alt={store.name} />
        </div>
      </div>
    </ModalContainer>
  );
};

export default wrapStore(PhotoDetailModal, Store);
